import { forwardRef } from 'react';
import { useCSVReader } from 'react-papaparse';
import intl from 'react-intl-universal';
import IconFileCode from 'components/icons/icn-file-code.icon';
import StyledCSVReader from './styled';
import { UploadMasterdata } from 'components/import-export-json/import-export-json.types';
import { validateDelimiter } from 'components/import-export-json/utils';

interface FileUploadProps<T> {
  handleReadFile: (data: IReadFile) => void;
  setCsv: (xls: any) => void;
  setErrors: (error: string[]) => void;
  setFileName: (fileName: string) => void;
}

export type IUploadAccepted<T> = {
  data: T[],
  errors: [],
  meta: []
}

type IAcceptedFile = {
  acceptedFile: File | null
  getRootProps: () => React.HTMLProps<HTMLDivElement>,
};

type IReadFile = IUploadAccepted<UploadMasterdata>;

const StyledCSVReaderWithRef = forwardRef<HTMLDivElement>((props) => (
  <StyledCSVReader {...props} />
));

const FileUpload = <T,>({ handleReadFile, setCsv, setErrors, setFileName }: FileUploadProps<T>) => {
  const { CSVReader } = useCSVReader();

  const handleUploadFile = (fileData: IReadFile) => {
    if (fileData.data.length > 2000) {
      setErrors([intl.get('master-data.general-configuration.maxLineError')]);
    } else {
      const _fileData = fileData.data.filter(item => Object.keys(item).length > 1) as unknown as UploadMasterdata;

      setCsv([_fileData]);
      handleReadFile({ data: [_fileData], errors: [], meta: [] });
    }
  };

  return (
    <CSVReader
      onUploadAccepted={handleUploadFile}
      config={{ encoding: 'iso-8859-1', header: true, delimiter: validateDelimiter() }}
    >
      {({ acceptedFile, getRootProps }: IAcceptedFile) => {
          if (acceptedFile?.name) {
            setFileName(acceptedFile.name);
          }
        return (
          <StyledCSVReaderWithRef {...getRootProps()} >
            <label>{intl.get('master-data.general.stockPolicyModal.archive')}</label>
            <div className="input-container">
              {!acceptedFile && <span>{intl.get('master-data.general.stockPolicyModal.searchArchive')}</span>}
              {acceptedFile && (
                <span>
                  {acceptedFile.name}
                </span>
              )}
              <div className="button-upload">
                <IconFileCode />
                <span>{intl.get('master-data.general.stockPolicyModal.select')}</span>
              </div>
            </div>
            <p>{intl.get('exportImportModal.masterData.maxLines')}</p>
          </StyledCSVReaderWithRef>
        );
      }}
    </CSVReader>
  );
}

export { FileUpload }